// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Menu":"bhp_a bie_h","Menu__offsetParent":"bhp_b bie_bj","Menu__trigger--shadowed":"bhp_c"};